module.exports = __webpack_public_path__ + "static/media/Expansions_card_bg_04.c5ed433b.jpg";